// Accounting contrepartie charge types — mirrors App\Enums\ChargeType on the backend.
// service_type_id: 1=Water, 2=Electricity, 3=Gas, null=applies to any service type.

const CHARGE_TYPES = [
  { value: 'water_general',   label: 'Water',          service_type_id: 1 },
  { value: 'water_tanker',    label: 'Water Tanker',   service_type_id: 1 },
  { value: 'water_sewer',     label: 'Sewer',          service_type_id: 1 },
  { value: 'electricity',     label: 'Electricity',    service_type_id: 2 },
  { value: 'gas',             label: 'Gas',            service_type_id: 3 },
  { value: 'meter_rental',    label: 'Meter Rental',   service_type_id: null },
  { value: 'service_charge',  label: 'Service Charge', service_type_id: null }
]

export { CHARGE_TYPES }

// Charge types relevant to a given service_type_id, primary type first
export function chargeTypesForServiceType (serviceTypeId) {
  const primary = CHARGE_TYPES.filter(ct => ct.service_type_id === serviceTypeId)
  const shared = CHARGE_TYPES.filter(ct => ct.service_type_id === null)
  return [...primary, ...shared]
}

export function chargeTypeLabel (value) {
  const match = CHARGE_TYPES.find(ct => ct.value === value)
  return match ? match.label : value
}



// WEBPACK FOOTER //
// ./src/utils/chargeTypes.js